import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/leanpub': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M386.5 111.5L401.6 360.4 390.7 360.2C354.4 359.3 319 368.9 288 388.2 257 368.9 221.6 360.2 185.3 360.2 139.8 360.2 103.3 370.9 61.8 387.9L93.1 129.6C121.7 117.8 154.6 111.5 185.3 111.5 226.5 111.5 259.2 124.7 288 154 315.7 125.8 347 112.3 386.5 111.5zM569.1 448C543.5 448 521.6 442.8 498.5 432.4 464.2 416.7 428.5 407.4 390.7 407.4 351.7 407.4 315.7 420.3 288 448 260.3 420.3 224.3 407.4 185.3 407.4 147.5 407.4 111.8 416.7 77.5 432.4 55.2 442.2 32.7 448 8.3 448H6.9L49.5 98.9C88.7 76.6 136.5 64 181.8 64 218.8 64 257 71.7 288 93.1 319 71.7 357.2 64 394.2 64 439.5 64 487.3 76.6 526.5 98.9L569.1 448zM525.7 403.3L491.7 123C460.9 109 424.4 101.6 390.7 101.6 352.2 101.6 316.3 113.7 288 140.3 259.7 113.7 223.8 101.6 185.3 101.6 151.6 101.6 115.1 109 84.3 123L50.3 403.3C97.5 383.8 133.2 369.8 185.3 369.8 222.9 369.8 256.2 379.4 288 399.4 319.8 379.4 353.1 369.8 390.7 369.8 442.8 369.8 478.5 383.8 525.7 403.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/leanpub.js
// module id = 7Fgl
// module chunks = 144